<script setup lang="ts">
import Lenis from 'lenis'

const lenis = ref<Lenis | null>(null)

onMounted(() => {
  // Initialize Lenis
  lenis.value = new Lenis({
    duration: 1.2,
    easing: (t: number) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothWheel: true,
  })

  // Use requestAnimationFrame to update Lenis
  function raf(time: number) {
    lenis.value?.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)

  // Provide lenis instance globally
  const nuxtApp = useNuxtApp()
  nuxtApp.provide('lenis', lenis.value)
})

onUnmounted(() => {
  lenis.value?.destroy()
})
</script>

<template>
  <span style="display: none"></span>
</template>

<style>
html.lenis,
html.lenis body {
  height: auto;
}

.lenis.lenis-smooth {
  scroll-behavior: auto !important;
}

.lenis.lenis-smooth [data-lenis-prevent] {
  overscroll-behavior: contain;
}

.lenis.lenis-stopped {
  overflow: hidden;
}

.lenis.lenis-scrolling iframe {
  pointer-events: none;
}
</style>
